import React from "react";

// Tiny "Live / Reconnecting" pill for pages fed by usePaymentEvents.
const LiveBadge = ({ connected }) => (
    <span
        className={`badge rounded-pill ${connected ? "bg-success-subtle text-success" : "bg-warning-subtle text-warning-emphasis"}`}
        title={connected ? "Updates arrive instantly" : "Live connection lost - refreshing every 15 seconds"}
    >
        <span
            style={{
                display: "inline-block", width: 7, height: 7, borderRadius: "50%", marginRight: 6,
                background: connected ? "#198754" : "#b58105",
            }}
        />
        {connected ? "Live" : "Reconnecting"}
    </span>
);

export default LiveBadge;
